export const PentagramIcon = () => {
  const radius = 50;
  const points = [];

  // Generate 5 outer points of the star
  for (let i = 0; i < 5; i++) {
    const angle = (Math.PI * 2 * i) / 5 - Math.PI / 2;
    points.push({
      x: radius * Math.cos(angle),
      y: radius * Math.sin(angle),
    });
  }

  // Order to draw a pentagram (connect every second point)
  const order = [0, 2, 4, 1, 3];

  const pathPoints = order.map(i => `${points[i].x},${points[i].y}`).join(' ');

  return (
    <svg width="40" height="40" viewBox={`-${radius} -${radius} ${radius * 2} ${radius * 2}`}>
      <polygon points={pathPoints} fill="#fff" stroke="#333" strokeWidth="2" />
    </svg>
  );
};